import { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Main, Flex } from '../../../components/styled/Layout';
import { Card, CardHeader, CardTitle, CardContent } from '../../../components/styled/Card';
import { SecondaryButton, PrimaryButton, DangerButton } from '../../../components/styled/Button';
import LoadingOverlay from '../../../components/LoadingOverlay';
import hestonService from '../services/hestonService';
import { computeAnalytics } from '../services/analyticsEngine';
import AddressDetailModal from '../components/AddressDetailModal';
import '../styles/ProjectDetail.css';
import KPICards from '../components/analytics/KPICards';
import PriceIndexChart from '../components/analytics/PriceIndexChart';
import StateComparisonChart from '../components/analytics/StateComparisonChart';
import SparklineGrid from '../components/analytics/SparklineGrid';
import PriceMap from '../components/analytics/PriceMap';
import ChangeEventTimeline from '../components/analytics/ChangeEventTimeline';
import InsightsPanel from '../components/analytics/InsightsPanel';
import PriceArchitectureChart from '../components/analytics/PriceArchitectureChart';
import CorrelationMatrix from '../components/analytics/CorrelationMatrix';
import WeeklyTrendChart from '../components/analytics/WeeklyTrendChart';
import DistributionChart from '../components/analytics/DistributionChart';
import CalendarHeatmap from '../components/analytics/CalendarHeatmap';
import RidgelinePlot from '../components/analytics/RidgelinePlot';
import CandlestickChart from '../components/analytics/CandlestickChart';
import DispersionChart from '../components/analytics/DispersionChart';
import RAGStatusTable from '../components/analytics/RAGStatusTable';
import PriceWarPanel from '../components/analytics/PriceWarPanel';
import SmallMultiples from '../components/analytics/SmallMultiples';
import SankeyDiagram from '../components/analytics/SankeyDiagram';
import ForecastChart from '../components/analytics/ForecastChart';
import StateRadarChart from '../components/analytics/StateRadarChart';
import PercentileBands from '../components/analytics/PercentileBands';
import TopMovers from '../components/analytics/TopMovers';
import WaterfallChart from '../components/analytics/WaterfallChart';
import BoxPlotTimeline from '../components/analytics/BoxPlotTimeline';
import ConvergenceChart from '../components/analytics/ConvergenceChart';
import PriceTierDonut from '../components/analytics/PriceTierDonut';
import HealthScore from '../components/analytics/HealthScore';
import FieldComparisonBar from '../components/analytics/FieldComparisonBar';
import SlopeChart from '../components/analytics/SlopeChart';
import CoverageTreemap from '../components/analytics/CoverageTreemap';
import ParallelCoordinates from '../components/analytics/ParallelCoordinates';
import DumbbellChart from '../components/analytics/DumbbellChart';
import HorizonChart from '../components/analytics/HorizonChart';
import BeeswarmPlot from '../components/analytics/BeeswarmPlot';
import VolatilityMatrix from '../components/analytics/VolatilityMatrix';
import LollipopChart from '../components/analytics/LollipopChart';
import PriceBandwidthChart from '../components/analytics/PriceBandwidthChart';
import StreamGraph from '../components/analytics/StreamGraph';
import PriceVelocityChart from '../components/analytics/PriceVelocityChart';
import MarimekkoChart from '../components/analytics/MarimekkoChart';
import DotMatrixChart from '../components/analytics/DotMatrixChart';
import BulletChart from '../components/analytics/BulletChart';
import NetworkGraph from '../components/analytics/NetworkGraph';
import GanttTimeline from '../components/analytics/GanttTimeline';
import PriceGapChart from '../components/analytics/PriceGapChart';
import RadialBarChart from '../components/analytics/RadialBarChart';
import PriceIndexComparison from '../components/analytics/PriceIndexComparison';
import PolarAreaChart from '../components/analytics/PolarAreaChart';
import SparkTable from '../components/analytics/SparkTable';
import ScatterMatrix from '../components/analytics/ScatterMatrix';
import MovingAverageChart from '../components/analytics/MovingAverageChart';
import TreemapPricing from '../components/analytics/TreemapPricing';
import SunburstChart from '../components/analytics/SunburstChart';
import PriceRangeSlider from '../components/analytics/PriceRangeSlider';
import ZScoreTimeline from '../components/analytics/ZScoreTimeline';
import ChordDiagram from '../components/analytics/ChordDiagram';
import PriceHeatmapGrid from '../components/analytics/PriceHeatmapGrid';
import CompetitivePositionChart from '../components/analytics/CompetitivePositionChart';
import MiniDashboard from '../components/analytics/MiniDashboard';
import ViolinPlot from '../components/analytics/ViolinPlot';
import PriceMomentumChart from '../components/analytics/PriceMomentumChart';
import SeasonalDecomposition from '../components/analytics/SeasonalDecomposition';
import RollingVolatilityChart from '../components/analytics/RollingVolatilityChart';
import PriceAnomalyTimeline from '../components/analytics/PriceAnomalyTimeline';
import StatePricePyramid from '../components/analytics/StatePricePyramid';
import PriceDecileChart from '../components/analytics/PriceDecileChart';
import CrossCorrelationChart from '../components/analytics/CrossCorrelationChart';
import PriceQuartileFlow from '../components/analytics/PriceQuartileFlow';
import PriceVarianceDecomposition from '../components/analytics/PriceVarianceDecomposition';
import PriceStabilityGauge from '../components/analytics/PriceStabilityGauge';
import GeographicClusterMap from '../components/analytics/GeographicClusterMap';
import StateRankingTimeline from '../components/analytics/StateRankingTimeline';
import PriceTargetChart from '../components/analytics/PriceTargetChart';
import AddressOutlierMap from '../components/analytics/AddressOutlierMap';
import PriceVolatilityHeatmap from '../components/analytics/PriceVolatilityHeatmap';
import PriceAccelerationChart from '../components/analytics/PriceAccelerationChart';
import StateCompetitiveLandscape from '../components/analytics/StateCompetitiveLandscape';
import PriceFunnelChart from '../components/analytics/PriceFunnelChart';
import PriceElasticityHeatmap from '../components/analytics/PriceElasticityHeatmap';
import PriceTrendRibbons from '../components/analytics/PriceTrendRibbons';
import StatePriceProfile from '../components/analytics/StatePriceProfile';
import PriceMemoryChart from '../components/analytics/PriceMemoryChart';
import StateClusterDendrogram from '../components/analytics/StateClusterDendrogram';
import PriceStickinessGauge from '../components/analytics/PriceStickinessGauge';
import PriceSurpriseIndex from '../components/analytics/PriceSurpriseIndex';
import CumulativeAnomalyChart from '../components/analytics/CumulativeAnomalyChart';
import ChangepointDetectionChart from '../components/analytics/ChangepointDetectionChart';
import PriceRatioStabilityChart from '../components/analytics/PriceRatioStabilityChart';
import MosquitoAvailabilityBoundaryMap from '../components/analytics/MosquitoAvailabilityBoundaryMap';
import PriceBucketMigrationTable from '../components/analytics/PriceBucketMigrationTable';
import AddressAnomalyScorecard from '../components/analytics/AddressAnomalyScorecard';
import RankStabilityChart from '../components/analytics/RankStabilityChart';
import DeviationFromBenchmarkChart from '../components/analytics/DeviationFromBenchmarkChart';
import CUSUMChart from '../components/analytics/CUSUMChart';
import ShewhartControlChart from '../components/analytics/ShewhartControlChart';
import EWMAChart from '../components/analytics/EWMAChart';
import PriceEntropyChart from '../components/analytics/PriceEntropyChart';
import BenfordAnalysis from '../components/analytics/BenfordAnalysis';
import PriceComplexityIndex from '../components/analytics/PriceComplexityIndex';
import LorenzCurveChart from '../components/analytics/LorenzCurveChart';
import QQPlot from '../components/analytics/QQPlot';
import HerfindahlIndexChart from '../components/analytics/HerfindahlIndexChart';
import MarkovTransitionMatrix from '../components/analytics/MarkovTransitionMatrix';
import MonteCarloFanChart from '../components/analytics/MonteCarloFanChart';
import BayesianUpdateChart from '../components/analytics/BayesianUpdateChart';
import GrangerCausalityMatrix from '../components/analytics/GrangerCausalityMatrix';
import LeadLagIndicatorChart from '../components/analytics/LeadLagIndicatorChart';
import ImpulseResponseChart from '../components/analytics/ImpulseResponseChart';
import RecurrencePlot from '../components/analytics/RecurrencePlot';
import PriceRunsTestChart from '../components/analytics/PriceRunsTestChart';
import SpectralDensityChart from '../components/analytics/SpectralDensityChart';
import WaveletScalogram from '../components/analytics/WaveletScalogram';
import PhasePortraitChart from '../components/analytics/PhasePortraitChart';
import LyapunovExponentChart from '../components/analytics/LyapunovExponentChart';
import StateSyncIndex from '../components/analytics/StateSyncIndex';
import SpectralCoherenceChart from '../components/analytics/SpectralCoherenceChart';
import RegressionDiscontinuityChart from '../components/analytics/RegressionDiscontinuityChart';
import QuantileRegressionFan from '../components/analytics/QuantileRegressionFan';
import ResidualsPlot from '../components/analytics/ResidualsPlot';
import ValueAtRiskChart from '../components/analytics/ValueAtRiskChart';
import PCABiplot from '../components/analytics/PCABiplot';
import TSNEClusterMap from '../components/analytics/TSNEClusterMap';
import FactorLoadingsChart from '../components/analytics/FactorLoadingsChart';
import RelativeStrengthIndex from '../components/analytics/RelativeStrengthIndex';
import PerformanceAttributionChart from '../components/analytics/PerformanceAttributionChart';
import AddressSimilarityMatrix from '../components/analytics/AddressSimilarityMatrix';
import PriceSignalNoiseChart from '../components/analytics/PriceSignalNoiseChart';
import EventStudyChart from '../components/analytics/EventStudyChart';
import CounterfactualChart from '../components/analytics/CounterfactualChart';
import ARIMAForecastCone from '../components/analytics/ARIMAForecastCone';
import EnsembleForecastChart from '../components/analytics/EnsembleForecastChart';
import PriceHalfLifeChart from '../components/analytics/PriceHalfLifeChart';
import PriceContagionMap from '../components/analytics/PriceContagionMap';
import PriceRegimeTransitionDiagram from '../components/analytics/PriceRegimeTransitionDiagram';
import InformationRatioChart from '../components/analytics/InformationRatioChart';
import PricePathDivergenceChart from '../components/analytics/PricePathDivergenceChart';
import PsychologicalPricingDensity from '../components/analytics/PsychologicalPricingDensity';
import BundleYieldCurve from '../components/analytics/BundleYieldCurve';
import UrbanRuralDivergence from '../components/analytics/UrbanRuralDivergence';
import HestonChatbot from '../components/analytics/HestonChatbot';
import FeatureVoteCard, { FeatureVoteContext } from '../components/analytics/FeatureVoteCard';


// Chart components

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

const TABS = [
    { id: 'pricing', label: 'Price Intelligence' },
    { id: 'executive', label: 'Executive Summary' },
    { id: 'geographic', label: 'Geographic & State' },
    { id: 'timeseries', label: 'Time Series' },
    { id: 'distributions', label: 'Distributions' },
    { id: 'volatility', label: 'Volatility & Risk' },
    { id: 'correlations', label: 'Correlations & Networks' },
    { id: 'changes', label: 'Change Detection' },
    { id: 'statistical', label: 'Statistical Models' },
    { id: 'spectral', label: 'Spectral & Dynamics' },
    { id: 'forecasting', label: 'Forecasting' },
    { id: 'quality', label: 'Data Quality' },
    { id: 'extra', label: 'Extra' },
];

const PROGRESS_MESSAGES = [
    'Fetching pricing history...',
    'Computing price indices...',
    'Analyzing geographic patterns...',
    'Detecting change events...',
    'Building correlation matrix...',
    'Identifying anomalies...',
];

// ---------------------------------------------------------------------------
// Sub-component: Price Comparison Cell
// ---------------------------------------------------------------------------

const PriceComparisonCell = ({ current, original }) => {
    if (!current && !original) return <span style={{ color: '#999' }}>-</span>;
    if (!original) return <span>{hestonService.formatCurrency(current)}</span>;

    const currVal = parseFloat(String(current).replace(/[$,]/g, '')) || 0;
    const origVal = parseFloat(String(original).replace(/[$,]/g, '')) || 0;

    if (currVal === origVal) return <span>{hestonService.formatCurrency(current)}</span>;

    const diff = currVal - origVal;
    const percent = origVal ? ((diff / origVal) * 100).toFixed(1) : 0;
    const color = diff > 0 ? '#27ae60' : '#c0392b';
    const arrow = diff > 0 ? '▲' : '▼';

    return (
        <div style={{ fontSize: '0.9em' }}>
            <div style={{ fontWeight: 'bold' }}>{hestonService.formatCurrency(current)}</div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: '1.2' }}>
                <span style={{ color, fontSize: '0.85em' }}>{arrow} {Math.abs(percent)}%</span>
                <span style={{ color: '#999', textDecoration: 'line-through', fontSize: '0.85em' }}>{hestonService.formatCurrency(original)}</span>
            </div>
        </div>
    );
};

// ---------------------------------------------------------------------------
// Main Dashboard Component
// ---------------------------------------------------------------------------


const HestonIntroduction = () => (
  <div style={{ 
    marginBottom: '32px', 
    padding: '24px', 
    backgroundColor: '#fff', 
    border: '1px solid #e5e7eb', 
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
  }}>
    <h1 style={{ color: '#0077B5', marginTop: 0, marginBottom: '16px', fontSize: '24px' }}>Welcome to the Heston Analytics Platform</h1>
    <p style={{ color: '#374151', lineHeight: '1.6', marginBottom: '20px' }}>
      Heston is a next-generation <strong>Portfolio Optimization and Pricing Intelligence</strong> ecosystem designed for high-resolution market oversight. 
      This workspace integrates three critical data pillars into a unified <strong>142-component</strong> analytical dashboard:
    </p>
    <ul style={{ color: '#374151', lineHeight: '1.6', marginBottom: '20px', paddingLeft: '20px' }}>
      <li><strong>Market Intelligence:</strong> Real-time benchmarking data derived from comprehensive industry-wide digital footprints, providing an external view of competitive positioning.</li>
      <li><strong>Strategic Simulation:</strong> Synthetic data generated via the <strong>Heston Simulation Engine</strong> to model "What-If" scenarios, inflation impacts, and future price elasticity.</li>
      <li><strong>Operational Integration:</strong> Secure links to internal business databases, providing a ground-truth view of actual portfolio performance and health.</li>
    </ul>
    <div style={{ backgroundColor: '#f0f9ff', padding: '16px', borderRadius: '6px', borderLeft: '4px solid #0077B5', marginBottom: '20px' }}>
      <h3 style={{ margin: '0 0 8px 0', color: '#0077B5', fontSize: '16px' }}>A Foundation for Growth</h3>
      <p style={{ margin: 0, color: '#1e40af', fontSize: '14px' }}>
        The Heston platform is not a static end-in-itself product, but a dynamic foundation designed for rapid evolution. 
        It serves as a high-tier basis for future customized development, allowing for bespoke modules and integrations that fully align with your specific business needs.
      </p>
    </div>
    <p style={{ color: '#374151', lineHeight: '1.6', margin: 0 }}>
      Below is <strong>Heston, your AI Product Manager and Data Analyst</strong>. He is equipped with a complete functional blueprint of this dashboard and is plugged directly into your project's live data. 
      He can help you navigate our vast analytical arsenal or brainstorm brand-new strategic modules.
    </p>
  </div>
);

export default function ProjectDetail() {
    const { projectId } = useParams();
    const navigate = useNavigate();

    // UI State
    const [project, setProject] = useState(null);
    const [addresses, setAddresses] = useState([]);
    const [filteredAddresses, setFilteredAddresses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('pricing');
    
    // Search & Filter State
    const [searchTerm, setSearchTerm] = useState('');
    const [sortField, setSortField] = useState('address');
    const [sortOrder, setSortOrder] = useState('asc');
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [showAddressModal, setShowAddressModal] = useState(false);

    // Feature Handlers
    const fileInputRef = useRef(null);

    const handleImportCSV = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        
        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                setLoading(true);
                const content = e.target.result;
                const result = await hestonService.parseCSV(content, projectId);
                alert(`Found ${result.addresses?.length || 0} addresses. Confirming import...`);
                await hestonService.confirmImport({
                    projectId,
                    addresses: result.addresses,
                    mappings: result.mappings
                });
                await loadData(true);
                alert('Import successful!');
            } catch (err) {
                alert('Import failed: ' + (err.message || 'Error'));
            } finally {
                setLoading(false);
            }
        };
        reader.readAsText(file);
    };

    // Row Action States
    const [rescrapingAddress, setRescrapingAddress] = useState(null);
    const [deletingAddress, setDeletingAddress] = useState(null);

    // Analytics State
    const [loadingAnalytics, setLoadingAnalytics] = useState(false);
    const [analytics, setAnalytics] = useState(null);
    const [progressMsg, setProgressMsg] = useState('');
    const [analyticsWarning, setAnalyticsWarning] = useState(null);
    const [featureVotes, setFeatureVotes] = useState({});

    // Refs
    const progressIntervalRef = useRef(null);
    const historyByAddressRef = useRef({});

    // ------------------------------------------------------------------
    // Data Loading
    // ------------------------------------------------------------------

    const startProgressMessages = useCallback((addressCount) => {
        let idx = 0;
        setProgressMsg(`Analyzing ${addressCount} addresses...`);
        progressIntervalRef.current = setInterval(() => {
            idx = (idx + 1) % PROGRESS_MESSAGES.length;
            setProgressMsg(PROGRESS_MESSAGES[idx]);
        }, 1800);
    }, []);

    const stopProgressMessages = useCallback(() => {
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
            progressIntervalRef.current = null;
        }
        setProgressMsg('');
    }, []);

    const loadData = useCallback(async (isSilentRefresh = false) => {
        if (!isSilentRefresh) setLoading(true);
        setError(null);
        setAnalyticsWarning(null);

        try {
            // Phase 1: Load metadata
            const [projectData, addressData, votesData] = await Promise.all([
                hestonService.getProject(projectId),
                hestonService.listAddresses(projectId),
                hestonService.getFeatureVotes(projectId)
            ]);
            setProject(projectData);
            setAddresses(addressData);
            setFeatureVotes(votesData || {});

            if (!addressData || addressData.length === 0) {
                setLoading(false);
                return;
            }

            // Phase 2: Load history for analytics
            setLoadingAnalytics(true);
            startProgressMessages(addressData.length);

            const builtHistory = {};
            const historyResults = await Promise.all(
                addressData.map(addr =>
                    hestonService.getAddressHistory(addr.addressId)
                        .then(history => ({ addressId: addr.addressId, history }))
                        .catch(() => ({ addressId: addr.addressId, history: [] }))
                )
            );
            historyResults.forEach(r => { builtHistory[r.addressId] = r.history; });
            historyByAddressRef.current = builtHistory;

            // Phase 3: Compute
            try {
                const computed = computeAnalytics(addressData, builtHistory);
                setAnalytics(computed);
            } catch (computeErr) {
                console.error('Analytics engine error:', computeErr);
                setAnalyticsWarning('Analysis engine error: ' + (computeErr.message || ''));
                setAnalytics({});
            }
        } catch (err) {
            console.error('Unified load failed:', err);
            setError('Failed to load workspace data. ' + (err.message || ''));
        } finally {
            setLoading(false);
            setLoadingAnalytics(false);
            stopProgressMessages();
        }
    }, [projectId, startProgressMessages, stopProgressMessages]);

    useEffect(() => { loadData(); }, [loadData]);

    // ------------------------------------------------------------------
    // Search/Sort
    // ------------------------------------------------------------------

    useEffect(() => {
        let filtered = addresses;
        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = addresses.filter(addr =>
                addr.address.toLowerCase().includes(term) ||
                addr.city.toLowerCase().includes(term) ||
                addr.state.toLowerCase().includes(term) ||
                addr.zipCode.includes(term)
            );
        }

        const sorted = [...filtered].sort((a, b) => {
            let aVal = a[sortField];
            let bVal = b[sortField];
            if (aVal == null) return 1;
            if (bVal == null) return -1;
            if (sortField === 'timeOfScrape') { aVal = new Date(aVal).getTime(); bVal = new Date(bVal).getTime(); }
            if (['pest365', 'pest365Plus', 'oneTime', 'initialServiceVisit'].includes(sortField)) {
                aVal = parseFloat(String(aVal).replace(/[$,]/g, '')) || 0;
                bVal = parseFloat(String(bVal).replace(/[$,]/g, '')) || 0;
            }
            if (sortField === 'buildingSqFt') { aVal = Number(aVal) || 0; bVal = Number(bVal) || 0; }
            if (typeof aVal === 'string') { aVal = aVal.toLowerCase(); bVal = String(bVal).toLowerCase(); }
            if (aVal < bVal) return sortOrder === 'asc' ? -1 : 1;
            if (aVal > bVal) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        });
        setFilteredAddresses(sorted);
    }, [searchTerm, addresses, sortField, sortOrder]);

    const handleSort = (field) => {
        if (sortField === field) { setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc'); }
        else { setSortField(field); setSortOrder('asc'); }
    };

    const handleDeleteAddress = async (addressId, addressText) => {
        if (!window.confirm(`Are you sure you want to delete ${addressText}?`)) return;
        try {
            setDeletingAddress(addressId);
            await hestonService.deleteAddress(addressId);
            await loadData(true);
        } catch (err) {
            alert('Failed to delete address: ' + (err.message || 'Error'));
        } finally {
            setDeletingAddress(null);
        }
    };

    const handleRescrapeAddress = async (addressId) => {
        try {
            setRescrapingAddress(addressId);
            if (hestonService.rescrapeAddress) {
                await hestonService.rescrapeAddress(addressId);
                await loadData(true);
            } else {
                alert('Rescrape not implemented in service');
            }
        } catch (err) {
            alert('Failed to rescrape: ' + (err.message || 'Error'));
        } finally {
            setRescrapingAddress(null);
        }
    };

    const handleFeatureVote = useCallback((featureNumber, vote) => {
        setFeatureVotes((prev) => {
            const next = { ...prev };
            if (vote) next[featureNumber] = vote;
            else delete next[featureNumber];
            return next;
        });
        hestonService.saveFeatureVote(projectId, featureNumber, vote);
    }, [projectId]);

    const voteCtx = useMemo(() => ({ votes: featureVotes, onVote: handleFeatureVote }), [featureVotes, handleFeatureVote]);

    // ------------------------------------------------------------------
    // Tab Rendering
    // ------------------------------------------------------------------

    const pricingTab = useMemo(() => {
        if (activeTab !== 'pricing') return null;
        return (
            <div>
                <HestonIntroduction />
                <FeatureVoteCard number={1000} name="1000 - AI Feature Request Chat">
                    <HestonChatbot analytics={analytics} projectId={projectId} />
                </FeatureVoteCard>
                <FeatureVoteCard number={0} name="Portfolio Address Explorer">
                    <Card style={{ marginBottom: 0 }}>
                        <CardHeader>
                            <Flex justify="space-between" align="center" wrap="wrap" gap="16px">
                                <CardTitle>Address List ({filteredAddresses.length})</CardTitle>
                                <Flex gap="12px" align="center">
                                    <div style={{ position: 'relative', width: '350px' }}>
                                        <input
                                            type="text"
                                            className="search-input"
                                            style={{ width: '100%', padding: '8px 12px', fontSize: '13px' }}
                                            placeholder="Filter portfolio..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <SecondaryButton style={{ fontSize: '12px' }} onClick={() => fileInputRef.current?.click()}>Import CSV</SecondaryButton>
                                    <PrimaryButton style={{ fontSize: '12px' }} onClick={() => setShowAddressModal(true)}>Add Address</PrimaryButton>
                                </Flex>
                            </Flex>
                        </CardHeader>
                        <CardContent style={{ padding: 0 }}>
                            <div className="address-table-container">
                                <table className="address-table">
                                    <thead>
                                        <tr>
                                            <th onClick={() => handleSort('address')} className="sortable-header">Address</th>
                                            <th onClick={() => handleSort('city')} className="sortable-header">City</th>
                                            <th onClick={() => handleSort('state')} className="sortable-header">ST</th>
                                            <th onClick={() => handleSort('pest365')} className="sortable-header text-right">Pest365</th>
                                            <th onClick={() => handleSort('pest365Plus')} className="sortable-header text-right">Pest365+</th>
                                            <th onClick={() => handleSort('oneTime')} className="sortable-header text-right">One-Time</th>
                                            <th onClick={() => handleSort('initialServiceVisit')} className="sortable-header text-right">Initial</th>
                                            <th onClick={() => handleSort('mosquitoTickControl')} className="sortable-header text-right">MTC</th>
                                            <th onClick={() => handleSort('timeOfScrape')} className="sortable-header">Updated</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredAddresses.map((addr) => (
                                            <tr key={addr.addressId}>
                                                <td className="address-cell">{addr.address}</td>
                                                <td>{addr.city}</td>
                                                <td>{addr.state}</td>
                                                <td className="text-right"><PriceComparisonCell current={addr.pest365} original={addr.original_pest365} /></td>
                                                <td className="text-right"><PriceComparisonCell current={addr.pest365Plus} original={addr.original_pest365Plus} /></td>
                                                <td className="text-right"><PriceComparisonCell current={addr.oneTime} original={addr.original_oneTime} /></td>
                                                <td className="text-right"><PriceComparisonCell current={addr.initialServiceVisit} original={addr.original_initialServiceVisit} /></td>
                                                <td className="text-right"><PriceComparisonCell current={addr.mosquitoTickControl} original={addr.original_mosquitoTickControl} /></td>
                                                <td className="date-cell">{hestonService.formatDate(addr.timeOfScrape).split(',')[0]}</td>
                                                <td className="text-center">
                                                    <Flex gap="4px" justify="center">
                                                        <button className="btn-table-action btn-view" onClick={() => { setSelectedAddress(addr); setShowAddressModal(true); }} title="View Details">🔍</button>
                                                        <button className="btn-table-action btn-rescrape" onClick={() => handleRescrapeAddress(addr.addressId)} disabled={rescrapingAddress === addr.addressId} title="Rescrape">{rescrapingAddress === addr.addressId ? '...' : '🔄'}</button>
                                                        <button className="btn-table-action btn-delete" onClick={() => handleDeleteAddress(addr.addressId, addr.address)} disabled={deletingAddress === addr.addressId} title="Delete">{deletingAddress === addr.addressId ? '...' : '🗑️'}</button>
                                                    </Flex>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </CardContent>
                    </Card>
                </FeatureVoteCard>

                <div style={{ marginTop: '24px' }}>
                    <FeatureVoteCard number={17} name="Service Price Indices"><PriceIndexComparison data={analytics?.priceIndexComparison} /></FeatureVoteCard>
                    <FeatureVoteCard number={18} name="Price Tier Distribution"><PriceTierDonut data={analytics?.donutData} /></FeatureVoteCard>
                    <FeatureVoteCard number={19} name="Price Range Distribution"><PriceRangeSlider data={analytics?.priceRangeData} /></FeatureVoteCard>
                    <FeatureVoteCard number={20} name="Pricing Portfolio Treemap"><TreemapPricing data={analytics?.treemapPricingData} /></FeatureVoteCard>
                    <FeatureVoteCard number={21} name="Service Tier Funnel"><PriceFunnelChart data={analytics?.funnelData} /></FeatureVoteCard>
                    <FeatureVoteCard number={22} name="Price Stickiness Monitor"><PriceStickinessGauge data={analytics?.stickinessData} /></FeatureVoteCard>
                    <FeatureVoteCard number={23} name="Cumulative Price Changes"><WaterfallChart data={analytics?.waterfallData} /></FeatureVoteCard>
                    <FeatureVoteCard number={24} name="Price Movement by State"><SlopeChart data={analytics?.slopeData?.slopes} firstDate={analytics?.slopeData?.firstDate} lastDate={analytics?.slopeData?.lastDate} /></FeatureVoteCard>
                    <FeatureVoteCard number={25} name="Price Architecture Analysis"><Card><CardHeader><CardTitle>Price Architecture</CardTitle></CardHeader><CardContent><PriceArchitectureChart timeline={analytics?.priceArchitecture?.timeline} /></CardContent></Card></FeatureVoteCard>
                    <FeatureVoteCard number={26} name="State Price Breakdown"><FieldComparisonBar data={analytics?.fieldComparisonData} /></FeatureVoteCard>
                    <FeatureVoteCard number={27} name="Market Composition"><MarimekkoChart data={analytics?.marimekkoData} /></FeatureVoteCard>
                    <FeatureVoteCard number={28} name="Premium Price Gap Analysis"><PriceGapChart data={analytics?.priceGapData} /></FeatureVoteCard>
                    <FeatureVoteCard number={29} name="Price Heatmap Grid"><PriceHeatmapGrid data={analytics?.heatmapGridData} /></FeatureVoteCard>
                    <FeatureVoteCard number={30} name="State Price Rankings"><LollipopChart data={analytics?.lollipopData} /></FeatureVoteCard>
                    <FeatureVoteCard number={31} name="State Rankings (Radial)"><RadialBarChart data={analytics?.radialBarData} /></FeatureVoteCard>
                    <FeatureVoteCard number={32} name="Price vs National Benchmark"><PriceTargetChart data={analytics?.targetData} /></FeatureVoteCard>
                </div>
            </div>
        );
    }, [activeTab, analytics, filteredAddresses, searchTerm, sortField, sortOrder, rescrapingAddress, deletingAddress]);

    const executiveTab = useMemo(() => {
        if (activeTab !== 'executive') return null;
        return (
            <div>
                <FeatureVoteCard number={1} name="Price War Early Warning"><PriceWarPanel data={analytics?.priceWarIndicators} /></FeatureVoteCard>
                <FeatureVoteCard number={2} name="Pricing Health Score"><HealthScore data={analytics?.healthScore} /></FeatureVoteCard>
                <FeatureVoteCard number={3} name="Price Stability Index"><PriceStabilityGauge data={analytics?.stabilityGaugeData} /></FeatureVoteCard>
                <FeatureVoteCard number={4} name="Price Surprise Index"><PriceSurpriseIndex data={analytics?.surpriseData} /></FeatureVoteCard>
                <FeatureVoteCard number={5} name="Anomaly Accumulation Monitor"><CumulativeAnomalyChart data={analytics?.cumulativeAnomalyData} /></FeatureVoteCard>
                <FeatureVoteCard number={6} name="Key Performance Indicators"><KPICards kpis={analytics?.kpis} /></FeatureVoteCard>
                <FeatureVoteCard number={7} name="Key Metrics Dashboard"><MiniDashboard data={analytics?.miniDashboardData} /></FeatureVoteCard>
                <FeatureVoteCard number={8} name="Performance Benchmarks"><BulletChart data={analytics?.bulletData} /></FeatureVoteCard>
                <FeatureVoteCard number={9} name="Portfolio Health Matrix"><DotMatrixChart data={analytics?.dotMatrixData} /></FeatureVoteCard>
                <FeatureVoteCard number={10} name="Auto-generated Insights"><InsightsPanel insights={analytics?.insights} /></FeatureVoteCard>
                <FeatureVoteCard number={11} name="Top Price Movers"><TopMovers data={analytics?.topMovers} /></FeatureVoteCard>
                <FeatureVoteCard number={12} name="CERTUS Price Index"><Card><CardHeader><CardTitle>CERTUS Price Index</CardTitle></CardHeader><CardContent><PriceIndexChart data={analytics?.priceIndex?.timeline} /></CardContent></Card></FeatureVoteCard>
                <FeatureVoteCard number={13} name="Price Trend & Forecast"><ForecastChart data={analytics?.forecastData} /></FeatureVoteCard>
                <FeatureVoteCard number={14} name="Price Change Calendar"><Card><CardHeader><CardTitle>Price Change Calendar</CardTitle></CardHeader><CardContent><CalendarHeatmap data={analytics?.calendarData} /></CardContent></Card></FeatureVoteCard>
                <FeatureVoteCard number={15} name="State Summary with Sparklines"><SparkTable data={analytics?.sparkTableData} /></FeatureVoteCard>
                <FeatureVoteCard number={16} name="Data Quality Overview"><RAGStatusTable data={analytics?.ragStatus} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const geographicTab = useMemo(() => {
        if (activeTab !== 'geographic') return null;
        return (
            <div>
                                    <FeatureVoteCard number={141} name="141 - Urban vs Rural Divergence">
                        <UrbanRuralDivergence data={analytics} />
                    </FeatureVoteCard>
                    <FeatureVoteCard number={33} name="Geographic Map & State Comparison">
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))', gap: 16 }}>
                        <Card><CardHeader><CardTitle>Pricing Map</CardTitle></CardHeader><CardContent><PriceMap geoData={analytics?.geoData} /></CardContent></Card>
                        <Card><CardHeader><CardTitle>State Comparison</CardTitle></CardHeader><CardContent><StateComparisonChart data={analytics?.stateAnalysis} /></CardContent></Card>
                    </div>
                </FeatureVoteCard>
                <FeatureVoteCard number={34} name="State Price Pyramid"><StatePricePyramid data={analytics?.pyramidData} /></FeatureVoteCard>
                <FeatureVoteCard number={35} name="State Pricing Profiles"><StatePriceProfile data={analytics?.statePriceProfileData} /></FeatureVoteCard>
                <FeatureVoteCard number={36} name="State Ranking Timeline"><StateRankingTimeline data={analytics?.stateRankingData} /></FeatureVoteCard>
                <FeatureVoteCard number={37} name="State Pricing Radar"><StateRadarChart data={analytics?.radarData} /></FeatureVoteCard>
                <FeatureVoteCard number={38} name="Geographic Cluster Map"><GeographicClusterMap data={analytics?.geographicClusterData} /></FeatureVoteCard>
                <FeatureVoteCard number={39} name="Competitive Position"><CompetitivePositionChart data={analytics?.competitivePositionData} /></FeatureVoteCard>
                <FeatureVoteCard number={40} name="State Competitive Landscape"><StateCompetitiveLandscape data={analytics?.competitiveLandscapeData} /></FeatureVoteCard>
                <FeatureVoteCard number={41} name="State Cluster Dendrogram"><StateClusterDendrogram data={analytics?.clusterDendrogramData} /></FeatureVoteCard>
                <FeatureVoteCard number={42} name="Elasticity Heatmap"><PriceElasticityHeatmap data={analytics?.elasticityHeatmapData} /></FeatureVoteCard>
                <FeatureVoteCard number={43} name="MTC Service Boundary"><MosquitoAvailabilityBoundaryMap data={analytics?.mosquitoBoundaryData} /></FeatureVoteCard>
                <FeatureVoteCard number={44} name="MTC Availability Profile"><SmallMultiples data={analytics?.smallMultiplesData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const timeseriesTab = useMemo(() => {
        if (activeTab !== 'timeseries') return null;
        return (
            <div>
                <FeatureVoteCard number={45} name="Historical Pricing Tracks"><SparklineGrid addresses={addresses} historyByAddress={historyByAddressRef.current} /></FeatureVoteCard>
                <FeatureVoteCard number={46} name="Weekly Price Trends"><WeeklyTrendChart data={analytics?.weeklyTrends} /></FeatureVoteCard>
                <FeatureVoteCard number={47} name="Price Volatility Analysis"><VolatilityMatrix data={analytics?.volatilityMatrix} /></FeatureVoteCard>
                <FeatureVoteCard number={48} name="Rolling Price Momentum"><PriceMomentumChart data={analytics?.momentumData} /></FeatureVoteCard>
                <FeatureVoteCard number={49} name="Seasonality Decomposition"><SeasonalDecomposition data={analytics?.seasonalData} /></FeatureVoteCard>
                <FeatureVoteCard number={50} name="Trend Path Visualization"><StreamGraph data={analytics?.streamData} /></FeatureVoteCard>
                <FeatureVoteCard number={51} name="Horizon Chart"><HorizonChart data={analytics?.horizonData} /></FeatureVoteCard>
                <FeatureVoteCard number={52} name="Moving Average Envelopes"><MovingAverageChart data={analytics?.movingAvgData} /></FeatureVoteCard>
                <FeatureVoteCard number={53} name="Price Z-Score Timeline"><ZScoreTimeline data={analytics?.zScoreData} /></FeatureVoteCard>
                <FeatureVoteCard number={54} name="Box Plot (Over Time)"><BoxPlotTimeline data={analytics?.boxPlotData} /></FeatureVoteCard>
                <FeatureVoteCard number={55} name="Price Change Gantt"><GanttTimeline data={analytics?.ganttData} /></FeatureVoteCard>
                <FeatureVoteCard number={56} name="Candlestick Chart"><CandlestickChart data={analytics?.candlestickData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics, addresses]);

    const distributionsTab = useMemo(() => {
        if (activeTab !== 'distributions') return null;
        return (
            <div>
                <FeatureVoteCard number={57} name="Price Histogram Density"><DistributionChart data={analytics?.distributions?.current} /></FeatureVoteCard>
                <FeatureVoteCard number={58} name="Ridgeline Plot"><RidgelinePlot data={analytics?.ridgelineData} /></FeatureVoteCard>
                <FeatureVoteCard number={59} name="Beeswarm Plot"><BeeswarmPlot data={analytics?.beeswarmData} /></FeatureVoteCard>
                <FeatureVoteCard number={61} name="Percentile Bands"><PercentileBands data={analytics?.percentileBands} /></FeatureVoteCard>
                <FeatureVoteCard number={62} name="Price Decile Analysis"><PriceDecileChart data={analytics?.decileData} /></FeatureVoteCard>
                <FeatureVoteCard number={63} name="Herfindahl Index"><HerfindahlIndexChart data={analytics?.herfindahlData} /></FeatureVoteCard>
                <FeatureVoteCard number={64} name="Lorenz Curve"><LorenzCurveChart data={analytics?.lorenzCurveData} /></FeatureVoteCard>
                <FeatureVoteCard number={65} name="Q-Q Plot"><QQPlot data={analytics?.qqPlotData} /></FeatureVoteCard>
                <FeatureVoteCard number={66} name="Violin Plot"><ViolinPlot data={analytics?.violinPlotData} /></FeatureVoteCard>
                <FeatureVoteCard number={67} name="Price Dispersion Map"><DispersionChart data={analytics?.dispersionData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const volatilityTab = useMemo(() => {
        if (activeTab !== 'volatility') return null;
        return (
            <div>
                <FeatureVoteCard number={69} name="Rolling Volatility"><RollingVolatilityChart data={analytics?.rollingVolatilityData} /></FeatureVoteCard>
                <FeatureVoteCard number={70} name="Value at Risk (VaR)"><ValueAtRiskChart data={analytics?.valueAtRiskData} /></FeatureVoteCard>
                <FeatureVoteCard number={74} name="Price Anomaly Timeline"><PriceAnomalyTimeline data={analytics?.anomalyTimelineData} /></FeatureVoteCard>
                <FeatureVoteCard number={76} name="Price Bandwidth Channels"><PriceBandwidthChart data={analytics?.bandwidthData} /></FeatureVoteCard>
                <FeatureVoteCard number={77} name="Price Acceleration Analysis"><PriceAccelerationChart data={analytics?.accelerationData} /></FeatureVoteCard>
                <FeatureVoteCard number={78} name="Variance Decomposition"><PriceVarianceDecomposition data={analytics?.varianceDecomposition} /></FeatureVoteCard>
                <FeatureVoteCard number={79} name="Volatility Heatmap"><PriceVolatilityHeatmap data={analytics?.volatilityHeatmapData} /></FeatureVoteCard>
                <FeatureVoteCard number={80} name="Volatility Rose Plot"><PolarAreaChart data={analytics?.polarAreaData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const correlationsTab = useMemo(() => {
        if (activeTab !== 'correlations') return null;
        return (
            <div>
                <FeatureVoteCard number={81} name="Price Field Correlations"><CorrelationMatrix matrix={analytics?.correlations?.matrix} /></FeatureVoteCard>
                <FeatureVoteCard number={82} name="Cross-Correlation Matrix"><CrossCorrelationChart data={analytics?.crossCorrelationData} /></FeatureVoteCard>
                <FeatureVoteCard number={83} name="Price Field Scatter Matrix"><ScatterMatrix data={analytics?.scatterMatrixData} /></FeatureVoteCard>
                <FeatureVoteCard number={84} name="State Correlation Network"><NetworkGraph data={analytics?.networkData} /></FeatureVoteCard>
                <FeatureVoteCard number={85} name="Price Parallel Coordinates"><ParallelCoordinates data={analytics?.parallelData} /></FeatureVoteCard>
                <FeatureVoteCard number={86} name="Similarity Chord Diagram"><ChordDiagram data={analytics?.chordData} /></FeatureVoteCard>
                <FeatureVoteCard number={87} name="Price Tier Migration Sankey"><SankeyDiagram data={analytics?.sankeyData} /></FeatureVoteCard>
                <FeatureVoteCard number={88} name="Pricing Hierarchy Sunburst"><SunburstChart data={analytics?.sunburstData} /></FeatureVoteCard>
                <FeatureVoteCard number={89} name="Service Coverage Treemap"><CoverageTreemap data={analytics?.treemapData} /></FeatureVoteCard>
                <FeatureVoteCard number={90} name="Quartile Migration Flow"><PriceQuartileFlow data={analytics?.quartileFlowData} /></FeatureVoteCard>
                <FeatureVoteCard number={91} name="Price Convergence Monitor"><ConvergenceChart data={analytics?.convergenceData} /></FeatureVoteCard>
                <FeatureVoteCard number={92} name="Address Similarity Matrix"><AddressSimilarityMatrix data={analytics?.addressSimilarityData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const changesTab = useMemo(() => {
        if (activeTab !== 'changes') return null;
        return (
            <div>
                <FeatureVoteCard number={93} name="Price Change Timeline"><ChangeEventTimeline events={analytics?.changeEvents} /></FeatureVoteCard>
                <FeatureVoteCard number={94} name="Structural Changepoint Map"><ChangepointDetectionChart data={analytics?.changepointData} /></FeatureVoteCard>
                <FeatureVoteCard number={96} name="Address Outlier Map"><AddressOutlierMap data={analytics?.addressOutlierData} /></FeatureVoteCard>
                <FeatureVoteCard number={97} name="Price Ratio Stability Chart"><PriceRatioStabilityChart data={analytics?.ratioStabilityData} /></FeatureVoteCard>
                <FeatureVoteCard number={98} name="Price Bucket Migration Matrix"><PriceBucketMigrationTable data={analytics?.bucketMigrationData} /></FeatureVoteCard>
                <FeatureVoteCard number={99} name="Address Anomaly Scorecard"><AddressAnomalyScorecard data={analytics?.anomalyScorecardData} /></FeatureVoteCard>
                <FeatureVoteCard number={100} name="Rank Stability Monitor"><RankStabilityChart data={analytics?.rankStabilityData} /></FeatureVoteCard>
                <FeatureVoteCard number={101} name="Deviation from Benchmark"><DeviationFromBenchmarkChart data={analytics?.deviationBenchmarkData} /></FeatureVoteCard>
                <FeatureVoteCard number={102} name="Price Persistence (Memory)"><PriceMemoryChart data={analytics?.priceMemoryData} /></FeatureVoteCard>
                <FeatureVoteCard number={103} name="Price Path Divergence"><PricePathDivergenceChart data={analytics?.pricePathDivergenceData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const statisticalTab = useMemo(() => {
        if (activeTab !== 'statistical') return null;
        return (
            <div>
                <FeatureVoteCard number={105} name="CUSUM Control Chart"><CUSUMChart data={analytics?.cusumData} /></FeatureVoteCard>
                <FeatureVoteCard number={106} name="Shewhart Control Chart"><ShewhartControlChart data={analytics?.shewhartData} /></FeatureVoteCard>
                <FeatureVoteCard number={107} name="EWMA Control Chart"><EWMAChart data={analytics?.ewmaData} /></FeatureVoteCard>
                <FeatureVoteCard number={108} name="Price Entropy Analysis"><PriceEntropyChart data={analytics?.entropyData} /></FeatureVoteCard>
                <FeatureVoteCard number={109} name="Benford's Law Diagnostic"><BenfordAnalysis data={analytics?.benfordData} /></FeatureVoteCard>
                <FeatureVoteCard number={110} name="Price Complexity Index"><PriceComplexityIndex data={analytics?.complexityData} /></FeatureVoteCard>
                <FeatureVoteCard number={111} name="Markov Transition Matrix"><MarkovTransitionMatrix data={analytics?.markovTransitionData} /></FeatureVoteCard>
                <FeatureVoteCard number={112} name="Bayesian Price Update"><BayesianUpdateChart data={analytics?.bayesianUpdateData} /></FeatureVoteCard>
                <FeatureVoteCard number={113} name="Granger Causality Matrix"><GrangerCausalityMatrix data={analytics?.grangerCausalityData} /></FeatureVoteCard>
                <FeatureVoteCard number={114} name="Lead-Lag Indicators"><LeadLagIndicatorChart data={analytics?.leadLagData} /></FeatureVoteCard>
                <FeatureVoteCard number={115} name="Runs Test Analysis"><PriceRunsTestChart data={analytics?.runsTestData} /></FeatureVoteCard>
                <FeatureVoteCard number={116} name="Regime Transition Diagram"><PriceRegimeTransitionDiagram data={analytics?.regimeTransitionData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const spectralTab = useMemo(() => {
        if (activeTab !== 'spectral') return null;
        return (
            <div>
                <FeatureVoteCard number={117} name="Spectral Density (FFT)"><SpectralDensityChart data={analytics?.spectralDensityData} /></FeatureVoteCard>
                <FeatureVoteCard number={118} name="Wavelet Scalogram"><WaveletScalogram data={analytics?.waveletScalogramData} /></FeatureVoteCard>
                <FeatureVoteCard number={119} name="Spectral Coherence Plot"><SpectralCoherenceChart data={analytics?.spectralCoherenceData} /></FeatureVoteCard>
                <FeatureVoteCard number={120} name="State Synchronization Index"><StateSyncIndex data={analytics?.stateSyncData} /></FeatureVoteCard>
                <FeatureVoteCard number={121} name="Phase Portrait (State-Space)"><PhasePortraitChart data={analytics?.phasePortraitData} /></FeatureVoteCard>
                <FeatureVoteCard number={122} name="Lyapunov Exponent (Chaos)"><LyapunovExponentChart data={analytics?.lyapunovExponentData} /></FeatureVoteCard>
                <FeatureVoteCard number={123} name="Impulse Response Function"><ImpulseResponseChart data={analytics?.impulseResponseData} /></FeatureVoteCard>
                <FeatureVoteCard number={124} name="Recurrence Plot (Dynamics)"><RecurrencePlot data={analytics?.recurrencePlotData} /></FeatureVoteCard>
                <FeatureVoteCard number={125} name="Regression Discontinuity"><RegressionDiscontinuityChart data={analytics?.regressionDiscontinuityData} /></FeatureVoteCard>
                <FeatureVoteCard number={126} name="Quantile Regression Fan"><QuantileRegressionFan data={analytics?.quantileRegressionData} /></FeatureVoteCard>
                <FeatureVoteCard number={127} name="Residuals Plot (Diagnostics)"><ResidualsPlot data={analytics?.residualsData} /></FeatureVoteCard>
                <FeatureVoteCard number={128} name="Price Velocity Profile"><PriceVelocityChart data={analytics?.velocityData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const forecastingTab = useMemo(() => {
        if (activeTab !== 'forecasting') return null;
        return (
            <div>
                <FeatureVoteCard number={129} name="ARIMA Forecast Cone"><ARIMAForecastCone data={analytics?.arimaForecastData} /></FeatureVoteCard>
                <FeatureVoteCard number={130} name="Monte Carlo Fan Chart"><MonteCarloFanChart data={analytics?.monteCarloFanData} /></FeatureVoteCard>
                <FeatureVoteCard number={131} name="Ensemble Forecast Cloud"><EnsembleForecastChart data={analytics?.ensembleForecastData} /></FeatureVoteCard>
                <FeatureVoteCard number={132} name="Price Half-Life Decay"><PriceHalfLifeChart data={analytics?.priceHalfLifeData} /></FeatureVoteCard>
                <FeatureVoteCard number={133} name="Price Contagion Map"><PriceContagionMap data={analytics?.priceContagionData} /></FeatureVoteCard>
                <FeatureVoteCard number={134} name="Information Ratio Profile"><InformationRatioChart data={analytics?.informationRatioData} /></FeatureVoteCard>
                <FeatureVoteCard number={135} name="Counterfactual Analysis"><CounterfactualChart data={analytics?.counterfactualData} /></FeatureVoteCard>
                <FeatureVoteCard number={136} name="Event Study Analysis"><EventStudyChart data={analytics?.eventStudyData} /></FeatureVoteCard>
                <FeatureVoteCard number={137} name="Signal vs Noise Decomposition"><PriceSignalNoiseChart data={analytics?.signalNoiseData} /></FeatureVoteCard>
                <FeatureVoteCard number={138} name="Performance Attribution"><PerformanceAttributionChart data={analytics?.performanceAttributionData} /></FeatureVoteCard>
                                    <FeatureVoteCard number={140} name="140 - Bundle Yield Curve">
                        <BundleYieldCurve data={analytics} />
                    </FeatureVoteCard>
                    <FeatureVoteCard number={139} name="Price Trend Ribbons"><PriceTrendRibbons data={analytics?.trendRibbonsData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const qualityTab = useMemo(() => {
        if (activeTab !== 'quality') return null;
        return (
            <div>
                <FeatureVoteCard number={142} name="PCA Biplot (Variance)"><PCABiplot data={analytics?.pcaBiplotData} /></FeatureVoteCard>
                <FeatureVoteCard number={143} name="t-SNE Cluster Projection"><TSNEClusterMap data={analytics?.tsneClusterData} /></FeatureVoteCard>
                <FeatureVoteCard number={144} name="Factor Loadings Analysis"><FactorLoadingsChart data={analytics?.factorLoadingsData} /></FeatureVoteCard>
                <FeatureVoteCard number={145} name="Relative Strength Index (RSI)"><RelativeStrengthIndex data={analytics?.rsiData} /></FeatureVoteCard>
                <FeatureVoteCard number={148} name="Dumbbell (Max-Min Range)"><DumbbellChart data={analytics?.dumbbellData} /></FeatureVoteCard>
                <FeatureVoteCard number={152} name="Detected Anomalies List">
                    {analytics?.anomalies?.length > 0 ? (
                        <Card style={{ marginBottom: 0 }}>
                            <CardContent style={{ padding: 0 }}>
                                <div className="address-table-container">
                                    <table className="address-table">
                                        <thead><tr><th>Address</th><th>Service</th><th>Anomaly</th></tr></thead>
                                        <tbody>
                                            {analytics.anomalies.slice(0, 10).map((a, i) => (
                                                <tr key={i}><td>{a.address}</td><td>{a.field}</td><td style={{ color: '#c0392b' }}>{a.type}</td></tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </CardContent>
                        </Card>
                    ) : (
                        <Card><CardContent><div style={{ padding: 20, textAlign: 'center', color: '#666' }}>No active model violations detected.</div></CardContent></Card>
                    )}
                </FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    const extraTab = useMemo(() => {
        if (activeTab !== 'extra') return null;
        return (
            <div>
                <FeatureVoteCard number={155} name="Psychological Pricing Density"><PsychologicalPricingDensity data={analytics?.psychologicalPricingData} /></FeatureVoteCard>
            </div>
        );
    }, [activeTab, analytics]);

    if (loading && !project) return <LoadingOverlay message="Loading Project Workspace..." />;

    if (error) return (
        <Container><Main><Card variant="outlined" style={{ borderColor: '#C0392B', background: '#F8D7DA' }}><CardContent>
            <h3 style={{ color: '#721C24', margin: '0 0 12px 0' }}>Error</h3>
            <p style={{ color: '#721C24', margin: '0 0 16px 0' }}>{error}</p>
            <SecondaryButton onClick={() => navigate('/heston')}>&larr; Back to Projects</SecondaryButton>
        </CardContent></Card></Main></Container>
    );

    return (
        <FeatureVoteContext.Provider value={voteCtx}>
        <Container>
            <Main>
                <Flex direction="column" gap="24px" align="stretch">
                    
                    <Flex justify="space-between" align="flex-start" wrap="wrap" gap="16px">
                        <div>
                            <SecondaryButton onClick={() => navigate('/heston')} style={{ marginBottom: '12px' }}>&larr; Back to Projects</SecondaryButton>
                            <Flex gap="12px" align="center">
                                <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#2C3E50', margin: 0 }}>{project?.name}</h1>
                                <span style={{ background: '#0077B5', color: 'white', padding: '2px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold' }}>PROJECT WORKSPACE</span>
                            </Flex>
                            <p style={{ fontSize: '14px', color: '#666', margin: '4px 0 0 0' }}>{project?.description}</p>
                        </div>
                        <Flex gap="12px">
                            <PrimaryButton onClick={() => navigate(`/heston/projects/${projectId}/prices`)} style={{ background: '#8e44ad', borderColor: '#8e44ad' }}>💰 Pricing Simulator</PrimaryButton>
                            <SecondaryButton onClick={() => loadData()}>Refresh</SecondaryButton>
                            <SecondaryButton onClick={() => hestonService.exportProjectCSV(projectId)}>📋 Export</SecondaryButton>
                        </Flex>
                    </Flex>

                    {loadingAnalytics && (
                        <Card style={{ marginBottom: 0, borderLeft: '4px solid #0077B5' }}><CardContent>
                            <Flex align="center" gap="12px">
                                <div className="spinner-inline-sm" style={{ width: '18px', height: '18px' }} />
                                <span style={{ fontSize: '14px', color: '#0077B5', fontWeight: 600 }}>{progressMsg || 'Updating Workspace...'}</span>
                            </Flex>
                        </CardContent></Card>
                    )}

                    {!loadingAnalytics && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', borderBottom: '1px solid #e5e7eb', paddingBottom: '8px' }}>
                            {TABS.map(tab => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    style={{
                                        padding: '8px 16px', fontSize: '13px', borderRadius: '8px', border: 'none', cursor: 'pointer',
                                        background: activeTab === tab.id ? '#0077B5' : 'transparent',
                                        color: activeTab === tab.id ? '#fff' : '#666',
                                        fontWeight: activeTab === tab.id ? 600 : 400
                                    }}
                                >{tab.label}</button>
                            ))}
                        </div>
                    )}

                    {!loadingAnalytics && (
                        <div style={{ animation: 'fadeIn 0.2s' }}>
                            {pricingTab}
                            {executiveTab}
                            {geographicTab}
                            {timeseriesTab}
                            {distributionsTab}
                            {volatilityTab}
                            {correlationsTab}
                            {changesTab}
                            {statisticalTab}
                            {spectralTab}
                            {forecastingTab}
                            {qualityTab}
                            {extraTab}
                        </div>
                    )}

                </Flex>
            </Main>
            {showAddressModal && selectedAddress && (
                <AddressDetailModal address={selectedAddress} onClose={() => { setShowAddressModal(false); setSelectedAddress(null); }} onUpdate={() => loadData(true)} />
            )}
            <input type="file" ref={fileInputRef} style={{ display: 'none' }} accept=".csv" onChange={handleImportCSV} />
        </Container>
        </FeatureVoteContext.Provider>
    );
}